/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Nucleus Admin API
 * Headless, multi-tenant commerce backend for jewelry brands.
 *
 * ## Surfaces
 *
 * | Prefix | Caller | Credential |
 * |---|---|---|
 * | `/platform/v1` | Platform operator | Platform token from **Platform: Auth** |
 * | `/admin/v1` | Staff of one organization | Staff token from **Admin: Auth** |
 * | `/storefront/v1` | A storefront | Store API key from **Admin: API keys** |
 * | `/public/v1` | Anyone (the brand application form) | None; rate limited per IP |
 *
 * Every credential is sent as `Authorization: Bearer <value>`. Use the **Authorize** button once and it applies to every request you try here.
 *
 * ## Conventions
 *
 * - **Ids** are UUID v7 strings. **Timestamps** are ISO 8601 in UTC. **Money** is `{ amount, currency }` with `amount` in integer minor units.
 * - **Lists** paginate by cursor: `?limit=20&cursor=...` in, `{ items, nextCursor }` out, `nextCursor` is `null` on the last page.
 * - **Errors** always use one envelope, `{ error: { code, message, requestId, details?, meta? } }`. Switch on `code`, never on `message`.
 * - **Request ids**: every response carries `x-request-id`. Quote it when reporting a problem.
 * - **Idempotency**: endpoints that create money-related state require an `Idempotency-Key` header; the header is listed on those endpoints.
 * - A record that belongs to another tenant answers **404**, never 403, so existence is not leaked.
 * OpenAPI spec version: 0.1.0
 */
import type {
  GetAdminV1OrgAuditLogs200,
  GetAdminV1OrgAuditLogsParams,
  OrganizationProfile,
  OrganizationSettings,
  UpdateOrganizationProfileRequest,
  UpdateOrganizationSettingsRequest
} from '../model';

import { customInstance } from '../../../transport/mutator';
import type { BodyType } from '../../../transport/mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary The organization's profile: name, logo and contact details
 */
export const getAdminV1Org = (

 options?: SecondParameter<typeof customInstance<OrganizationProfile>>,) => {
      return customInstance<OrganizationProfile>(
      {url: `/admin/v1/org`, method: 'GET'
    },
      options);
    }
  /**
 * `logoMediaId` must be a media item of this organization (422 INVALID_REFERENCE otherwise). The slug never changes
 * @summary Change the organization's name, logo or contact details (owners only)
 */
export const patchAdminV1Org = (
    updateOrganizationProfileRequest: BodyType<UpdateOrganizationProfileRequest>,
 options?: SecondParameter<typeof customInstance<OrganizationProfile>>,) => {
      return customInstance<OrganizationProfile>(
      {url: `/admin/v1/org`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationProfileRequest
    },
      options);
    }
  /**
 * @summary Organization-wide settings
 */
export const getAdminV1OrgSettings = (

 options?: SecondParameter<typeof customInstance<OrganizationSettings>>,) => {
      return customInstance<OrganizationSettings>(
      {url: `/admin/v1/org/settings`, method: 'GET'
    },
      options);
    }
  /**
 * `security.requireTwoFactor` on means every staff member without two-factor gets 403 TWO_FACTOR_REQUIRED on everything except sign-in, /me and the two-factor endpoints until they enroll. `catalog.defaultWeightUnit` is the unit the admin weight picker starts on; it never converts stored weights
 * @summary Change organization-wide settings (owners only)
 */
export const patchAdminV1OrgSettings = (
    updateOrganizationSettingsRequest: BodyType<UpdateOrganizationSettingsRequest>,
 options?: SecondParameter<typeof customInstance<OrganizationSettings>>,) => {
      return customInstance<OrganizationSettings>(
      {url: `/admin/v1/org/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationSettingsRequest
    },
      options);
    }
  /**
 * Every state change writes a row here, including platform operators' support sessions. Filter by actor, action (exact, or a prefix ending in `.`), entity, store and time; a member restricted to some stores cannot filter on another store
 * @summary Who did what in the organization, newest first
 */
export const getAdminV1OrgAuditLogs = (
    params?: GetAdminV1OrgAuditLogsParams,
 options?: SecondParameter<typeof customInstance<GetAdminV1OrgAuditLogs200>>,) => {
      return customInstance<GetAdminV1OrgAuditLogs200>(
      {url: `/admin/v1/org/audit-logs`, method: 'GET',
        params
    },
      options);
    }
  export type GetAdminV1OrgResult = NonNullable<Awaited<ReturnType<typeof getAdminV1Org>>>
export type PatchAdminV1OrgResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1Org>>>
export type GetAdminV1OrgSettingsResult = NonNullable<Awaited<ReturnType<typeof getAdminV1OrgSettings>>>
export type PatchAdminV1OrgSettingsResult = NonNullable<Awaited<ReturnType<typeof patchAdminV1OrgSettings>>>
export type GetAdminV1OrgAuditLogsResult = NonNullable<Awaited<ReturnType<typeof getAdminV1OrgAuditLogs>>>
